import React from "react";
import {
  Page,
  Text,
  Image,
  Document,
  StyleSheet,
  View,
} from "@react-pdf/renderer";

const logoBase64 = null;

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    paddingTop: 40,
    paddingBottom: 60,
    paddingHorizontal: 40,
    fontSize: 12,
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingBottom: 10,
  },

  logo: {
    width: 50,
    height: 50,
  },

  title: {
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    flexGrow: 1,
    marginTop: 10,
  },

  headerText: {
    fontSize: 8,
    marginBottom: 3,
    textAlign: "right",
  },

  section: {
    marginBottom: 20,
  },

  questionTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    marginBottom: 5,
  },

  text: {
    fontSize: 12,
    marginBottom: 5,
    whiteSpace: "pre-wrap",
  },
});

const renderComment = (comment) => {
  return <Text style={styles.text}>{comment || ""}</Text>;
};

const MyDocument = ({ report, userLang }) => {
  const formattedDate = report?.dateComplete
    ? new Date(report.dateComplete).toLocaleString()
    : "";

  const questions = Array.isArray(report?.listeQuestions)
    ? report.listeQuestions
    : [];

  const responses = Array.isArray(report?.listeReponses)
    ? report.listeReponses
    : [];

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {/* HEADER */}
        <View style={styles.header} fixed>
          {logoBase64 && <Image style={styles.logo} src={logoBase64} />}

          <Text style={styles.title}>
            {userLang === "EN"
              ? report?.titleRepportEn || ""
              : report?.titleRepportFr || ""}
          </Text>

          <View>
            <Text style={styles.headerText}>Date: {formattedDate}</Text>

            <Text style={styles.headerText}>
              Restaurant: {report?.nomEmplacement || ""}
            </Text>

            <Text style={styles.headerText}>
              Author: {report?.username || ""}
            </Text>
          </View>
        </View>

        {/* QUESTIONS */}
        {questions.map((q) => {
          const questionResponses = responses.filter(
            (rep) => rep?.idQuestion === q?.id,
          );

          return (
            <View key={`q-${q.id}`} style={styles.section} wrap={false}>
              <Text style={styles.questionTitle}>
                {userLang === "EN" ? q?.textEn || "" : q?.textFr || ""}
              </Text>

              {questionResponses.length > 0 ? (
                questionResponses.map((rep) => (
                  <View key={`rep-${rep.id}`}>
                    {renderComment(rep?.commentaire)}
                  </View>
                ))
              ) : (
                <Text style={styles.text}></Text>
              )}

              {/* Sous-questions */}
              {Array.isArray(q?.childQuestions) &&
                q.childQuestions.map((qc) => {
                  const childResponses = responses.filter(
                    (rep) => rep?.idQuestion === qc?.id,
                  );

                  return (
                    <View key={`qc-${qc.id}`} style={{ marginTop: 10 }}>
                      <Text style={styles.questionTitle}>
                        {userLang === "EN"
                          ? qc?.textEn || ""
                          : qc?.textFr || ""}
                      </Text>

                      {childResponses.length > 0 ? (
                        childResponses.map((rep) => (
                          <View key={`rep-${rep.id}`}>
                            {renderComment(rep?.commentaire)}
                          </View>
                        ))
                      ) : (
                        <Text style={styles.text}></Text>
                      )}
                    </View>
                  );
                })}
            </View>
          );
        })}
      </Page>
    </Document>
  );
};

export default MyDocument;
